import React, { useEffect, useMemo, useState } from "react";
import Transcript from "../../../Student/ScoreGrade/PrintTranscript/Transcript";
import { GET_SCR_STUDENT_BY_ATPID } from "../../APIS";

export function CCPStd({ studentData }) {
  const [currSemes, setCurrSemes] = useState({ atpid: 0, data: [] });
  const semesStatus = useMemo(()=>{
    let computedData = [];
    if(studentData.semester_status && Object.values(studentData.semester_status).length > 0){
      computedData = studentData.semester_status.sort((a, b) => (a.semester > b.semester ? 1 : -1));  
      setCurrSemes({ atpid: computedData[0].atp_term.id, data: computedData[0] });
    }
    return computedData;
  },[studentData]);
  
  const [subject, setSubject] = useState({
    loading: false,
    message: "",
    data: [],
  });

  const ReloadData = async (param) => {
    setSubject({ loading: true, data: [], message: "" });
    const results = await GET_SCR_STUDENT_BY_ATPID(param);
    if(results.data && Object.values(results.data).length > 0){
      setSubject({loading: false, data: results.data, message: "" });
    }else{
      setSubject({loading: false, data: results, message: "" });
    }
  };

  useEffect(()=>{
    if(currSemes.atpid){
      HandlerSemester(currSemes.atpid);
    }
  },[currSemes.atpid])

  const HandlerSemester = (atpid) => {
    const findSemes = semesStatus.find((item) => item.atp_term.id === atpid);
    setCurrSemes({ atpid: atpid, data: findSemes });
    var param = {
      studentid: studentData?.studentid,
      atpid: atpid,
    };
    ReloadData(param);
  };

  return (
    <div className="row">
      <div className="col-4 col-xxl-3">
        <div className="card card-custom gutter-b">
          <div className="card-body">
            <h3>{studentData?.firstname}'s Course Plan</h3>
            <select
              name="semester"
              className="form-control"
              value={currSemes.atpid}
              onChange={(e) => HandlerSemester(parseInt(e.target.value))}
            >
              <option value="0">Choose Semester</option>
              {Object.values(semesStatus).length > 0
                ? semesStatus.map((s, index) => (
                    <option value={s.atp_term.id} key={index}>
                      {s.atp_term.name.includes("Short") && "Short"} Semester{" "}
                      {s.semester}
                    </option>
                  ))
                : ""}
            </select>
          </div>
        </div>
      </div>
      <div className="col-8 col-xxl-9">
        <div className="">
          {currSemes.data ? (
            <Transcript
              studentData={studentData}
              selected={currSemes.data.semester}
              CurrentSemesStatus={currSemes.data}
              CoursePlan={subject}
            />
          ) : (
            ""
          )}
        </div>
      </div>
    </div>
  );
}
